import ViewItems from "./viewItems";
import React from "react";

const BLANK_DEMOGRAPHIC_INFO = {
  layoutVersion: '',
  submissionType: '',
  schoolYear: '',
  sisType: '',
  sisInfo: '',
  extractVendorName: '',
  extractVendorPhone: '',
  programIdentifier: '',
  programName: '',
  authenticationKey: '',
  numberOfTranscripts: '',
  carnegieUnitConversionFactor: '',
  gradingSystem: '',
  calTypeCy: '',
  schoolYearStartMonthCy: '',
  schoolYearEndMonthCy: '',
  calTypeCy1: '',
  SchoolYearStartMonthCy1: '',
  SchoolYearEndMonthCy1: '',
  calTypeCy2: '',
  SchoolYearStartMonthCy2: '',
  SchoolYearEndMonthCy2: '',
  calTypeCy3: '',
  SchoolYearStartMonthCy3: '',
  SchoolYearEndMonthCy3: '',
  programEnrollment9: '',
  programEnrollment10: '',
  programEnrollment11: '',
  programEnrollment12: '',
  doorwaysMatchingCourseName: '',
  schoolComment: '',
  extractDate: '',
  EOR: ''
}

const DEMOGRAPHIC_LABELS = {
  columnOne: {
    layoutVersion: 'Layout Version',
    submissionType: 'Submission Type',
    schoolYear: 'School Year',
    sisType: 'SIS Type',
    sisInfo: 'SIS Info',
    extractVendorName: 'Extract Vendor Name',
    extractVendorPhone: 'Extract Vendor Phone',
    programIdentifier: 'Program Identifier',
    programName: 'Progam Name',
    authenticationKey: 'Authenication Key',
    numberOfTranscripts: 'Number of Transcripts',
    carnegieUnitConversionFactor: 'Carnegie Unit Conversion Factor',
    gradingSystem: 'Grading System',
    calTypeCy: 'Cal Type Cy',
    schoolYearStartMonthCy: 'School Year Start Month Cy',
    schoolYearEndMonthCy: 'School Year End Month Cy',
    calTypeCy1: 'Cal Type Cy 1'
  },
  columnTwo: {
    SchoolYearStartMonthCy1: 'School Year Start Month Cy 1',
    SchoolYearEndMonthCy1: 'School Year End Month Cy 1',
    calTypeCy2: 'Cal Type Cy 2',
    SchoolYearStartMonthCy2: 'School Year Start Month Cy 2',
    SchoolYearEndMonthCy2: 'School Year End Month Cy 2',
    calTypeCy3: 'Cal Type Cy 3',
    SchoolYearStartMonthCy3: 'School Year Start Month Cy 3',
    SchoolYearEndMonthCy3: 'School Year End Month Cy 3',
    programEnrollment9: 'Program Enrollment 9',
    programEnrollment10: 'Program Enrollment 10',
    programEnrollment11: 'Program Enrollment 11',
    programEnrollment12: 'Program Enrollment 12',
    doorwaysMatchingCourseName: 'Doorways Matching Course Name',
    schoolComment: 'School Comment',
    extractDate: 'Extract Date',
    EOR: 'EOR'
  }
}

const DemographicInfo = (props) => {
  const {
    demographicInfo
  } = props;

  const demographicItems = (demographicInfo) ? demographicInfo : BLANK_DEMOGRAPHIC_INFO;

  return (
    <div className='school-demographic-info'>
      <div className='school-demographic-header'>
        <div className='view-title'>School Demographic Info</div>
      </div>
      <div className='school-demographic-body'>
        <div className='demographic-column'>
          <ViewItems labels={DEMOGRAPHIC_LABELS.columnOne} items={demographicItems}/>
        </div>
        <div className='demographic-column'>
          <ViewItems labels={DEMOGRAPHIC_LABELS.columnTwo} items={demographicItems}/>
        </div>
      </div>
    </div>
  );
}

export default DemographicInfo;